
import React from "react";
import { Clock, CheckCircle2, ShieldCheck } from "lucide-react";

type Step = {
  id: string;
  name: string;
  description: string;
  completed: boolean;
  current?: boolean;
  icon: React.FC<{ className?: string }>;
};

interface StatusStepperProps {
  steps: Step[];
}

const StatusStepper: React.FC<StatusStepperProps> = ({ steps }) => {
  return (
    <div className="relative">
      <div className="absolute left-6 top-0 bottom-0 w-0.5 bg-muted" />
      
      <div className="space-y-8">
        {steps.map((step) => (
          <div key={step.id} className="relative pl-14">
            <div className={`absolute left-0 p-2 rounded-full ${
              step.completed 
                ? "bg-primary text-primary-foreground" 
                : step.current 
                  ? "bg-amber-500 text-white" 
                  : "bg-muted text-muted-foreground"
            }`}>
              <step.icon className="h-5 w-5" />
            </div>
            
            <h3 className="font-medium text-lg flex items-center gap-2">
              {step.name}
              {step.current && <span className="text-sm font-normal text-muted-foreground">(In Progress)</span>}
            </h3>
            
            <p className="text-muted-foreground mt-1">{step.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StatusStepper;
